import React from 'react'

const LeaveTypes = () => {
  return (
    <div>LeaveTypes</div>
  )
}

export default LeaveTypes